import { Component, OnInit } from '@angular/core';

interface CardItem {
  title: string;
  description: string;
  image: string;
  url?: string;
  button_text?: string;
  isInternal?: boolean;
}

@Component({
  selector: 'app-sblock-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class SblockCardsComponent implements OnInit {
  title = 'Nuestros programas destacados';
  subtitleText = 'Formacion y acompanamiento para toda la comunidad.';
  showTitles = true;

  currentIndex = 0;
  primaryColor = '#932f29';
  isHovered = false;

  expandedSet = new Set<number>();

  cards: CardItem[] = [
    {
      title: 'Curso de Formacion Humana',
      description:
        'Un itinerario completo de acompanamiento personal y crecimiento integral, ' +
        'pensado para quienes desean profundizar en su vocacion de servicio. ' +
        'Incluye sesiones presenciales, materiales de estudio y tutorias personalizadas ' +
        'a lo largo de todo el ano academico.',
      image: 'https://picsum.photos/seed/cards-one/640/370',
      url: '#',
      button_text: 'Mas informacion',
      isInternal: false
    },
    {
      title: 'Talleres de Espiritualidad',
      description:
        'Espacios de encuentro y reflexion guiados por especialistas, donde se trabajan ' +
        'la oracion, el silencio y la vida comunitaria. Una propuesta abierta a todas las ' +
        'edades para enriquecer la experiencia personal y de grupo.',
      image: 'https://picsum.photos/seed/cards-two/640/370',
      url: '#',
      button_text: 'Inscribirme',
      isInternal: false
    },
    {
      title: 'Voluntariado Social',
      description:
        'Participa en nuestros proyectos solidarios y acompana a las personas mas ' +
        'vulnerables. Ofrecemos formacion previa, seguimiento continuo y una red de ' +
        'voluntarios comprometidos con la transformacion social.',
      image: 'https://picsum.photos/seed/cards-three/640/370',
      url: '#',
      button_text: 'Quiero colaborar',
      isInternal: false
    }
  ];

  ngOnInit(): void {}

  hasTitleLink(): boolean {
    return false;
  }

  gotToLink(): void {}

  nextSlide(): void {
    if (this.currentIndex < this.cards.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }

  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.cards.length - 1;
    }
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  getImage(item: CardItem): string {
    return item ? item.image : '';
  }

  isExpanded(index: number): boolean {
    return this.expandedSet.has(index);
  }

  isOverflowing(index: number): boolean {
    return true;
  }

  toggleExpand(index: number, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.expandedSet.has(index)) {
      this.expandedSet.delete(index);
    } else {
      this.expandedSet.add(index);
    }
  }

  getTransform(): string {
    const slideWidthWithGap = 87;
    const offset = 7.5;
    return `translateX(calc(-${this.currentIndex * slideWidthWithGap}% + ${offset}%))`;
  }
}
